<template>
  <div class="page" v-wechat-title="$route.meta.title='授权'">

    <div class='authorize-wrapper'>
      <div class='authorize-main'>
        <div class='authorize-content'>
          <div class='authorize-head'>
            <div class='authorize-title'>缓存数据：</div>
          </div>
          <div class='authorize-summary'>userInfo：{{userInfo || '暂无数据'}}</div>
          <div class='M-summary'>userInfo1：{{userInfo1 || '暂无数据'}}</div>

          <div class='authorize-btn' @click="clearData"> 清除缓存 </div>

        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {setStore, getStore, removeStore} from '@/config/mUtils'

import wxConfirm from '@/wechat-messagebox/Confirm'
import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

export default {
    data(){
        return{
          userInfo: '', //用户信息
          userInfo1: '', //用户信息
        }
    },
    created() {

      this.userInfo = window.sessionStorage.getItem('userInfo');
      this.userInfo1 = window.localStorage.getItem('userInfo1');
    },
    mounted() {


    },
    methods: {

      clearData: function(){
        this.$confirm({
          title: '提示',
          content: '确认要清除页面缓存吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            localStorage.clear();
            sessionStorage.clear();

          }
        });
      },

    },
    components: {

    },

}

</script>

<style scoped>

  .page{ background:  #f9f9f9; min-height: 100vh; padding-bottom: 0; }

  .authorize-wrapper {

    height: 100vh;
    width: 100vw;
  }

  .authorize-wrapper .authorize-main {
    position: absolute;
    top: 1.50rem;
    left: 5%;
    width: 90%;
    background: #fff;
    color: #333;
    line-height: .48rem;
  }

  .authorize-wrapper .authorize-main .authorize-content {
    padding: .20rem .20rem .60rem;
  }

  .authorize-wrapper .authorize-main .authorize-summary {
    font-size: .28rem;
    line-height: 2;
    padding: 0 .15rem;
    word-break: break-word;
  }

  .authorize-wrapper .authorize-main .M-summary {
    padding-bottom: .60rem;
    font-size: .24rem;
    color: #999;
    padding: 0 .15rem;
    word-break: break-word;
  }

  .authorize-wrapper .authorize-head {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: .40rem 0;
  }

  .authorize-wrapper .authorize-head img {
    height: .80rem;
    width: 3.00rem;
    border-radius: .08rem;
    overflow: hidden;
  }

  .authorize-wrapper .authorize-head .authorize-title {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: .36rem;
    line-height: .80rem;
    padding: 0 .15rem;
  }

  .authorize-wrapper .authorize-btn {
    display: block;
    width: 100%;
    height: .80rem;
    line-height: .80rem;
    margin: .9rem auto 0;
    font-size: .32rem;
    letter-spacing: .02rem;
    color: #030201;
    background: #ffc000;
    text-align: center;
  }




</style>



// WEBPACK FOOTER //
// src/page/home/clear.vue